import { render, staticRenderFns } from "./TableGroupVouchers.vue?vue&type=template&id=4476d767"
import script from "./TableGroupVouchers.vue?vue&type=script&lang=js"
export * from "./TableGroupVouchers.vue?vue&type=script&lang=js"
import style0 from "./TableGroupVouchers.vue?vue&type=style&index=0&id=4476d767&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports